export var EAGER_LOAD_STRATEGY = 'eager';
export var LAZY_LOAD_STRATEGY = 'lazy';
export var IMAGE_LOAD_STRATEGIES = [EAGER_LOAD_STRATEGY, LAZY_LOAD_STRATEGY];